import React from 'react';
import { letterBlocks, parseLetterMarks } from '../../utils/quoteLetter';

function sized(node: React.ReactNode, size: 'small' | 'normal' | 'large') {
  if (size === 'normal') return node;
  return <span className={`letter-size-${size}`}>{node}</span>;
}

export default function LetterText({ text }: { text: string }) {
  const runs = parseLetterMarks(text);
  return (
    <>
      {runs.map((run, index) => {
        let node: React.ReactNode = run.text;
        if (!run.text) return null;
        if (run.underline) node = <u>{node}</u>;
        if (run.italic) node = <em>{node}</em>;
        if (run.bold) node = <strong>{node}</strong>;
        return <React.Fragment key={index}>{sized(node, run.size)}</React.Fragment>;
      })}
    </>
  );
}

export function LetterFlow({ lines, paragraphClassName }: { lines: string[]; paragraphClassName?: string }) {
  const blocks = letterBlocks(lines);
  return (
    <>
      {blocks.map((block, index) => {
        if (block.type === 'bullet') {
          return (
            <ul key={index}>
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item ? <LetterText text={item} /> : <br />}</li>
              ))}
            </ul>
          );
        }
        if (block.type === 'number') {
          return (
            <ol key={index}>
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex} value={Number(item.marker) || undefined}>
                  {item.text ? <LetterText text={item.text} /> : <br />}
                </li>
              ))}
            </ol>
          );
        }
        return (
          <p className={paragraphClassName} key={index}>
            {block.lines.map((line, lineIndex) => (
              <React.Fragment key={lineIndex}>
                {lineIndex > 0 ? <br /> : null}
                <LetterText text={line} />
              </React.Fragment>
            ))}
          </p>
        );
      })}
    </>
  );
}
